import React from "react";
import { LockKeyhole } from "lucide-react";
import { useTranslation } from "react-i18next";

export function KycFooter() {
  const { t } = useTranslation();

  return (
    <footer className="kyc-portal-footer relative z-10 px-5 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-2 sm:px-8 sm:pb-7 sm:pt-4">
      <div className="mx-auto flex w-full max-w-3xl items-center justify-center gap-2 text-xs text-white/55">
        <LockKeyhole className="size-3.5" aria-hidden="true" />
        <span>{t("kyc.portal.secureFooter")}</span>
      </div>
    </footer>
  );
}
